import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import Terms from "./views/Terms.vue";
import Contact from "./views/Contact.vue";
import PageNotFound from "./views/PageNotFound.vue";
import Buy from "./views/Buy.vue";
import Debt from "./views/Debt.vue";
import ApproveConsignment from "./views/ApproveConsignment.vue";
import ApprovePurchase from "./views/ApprovePurchase.vue";
import Dashboard from "./views/Dashboard.vue";
import Config from "./views/Config.vue";
import Consignment from "./views/Consignment.vue";
import Api from "./views/Api.vue";
import Companies from "./views/Companies.vue";

Vue.use(Router);

var r = {
  routes: [
    {
      path: "/",
      name: "home",
      component: Login
    },

    {
      path: "/terms",
      name: "terms",
      component: Terms
    },
    {
      path: "/contact",
      name: "contact",
      component: Contact
    },

    {
      path: "/login",
      name: "login",
      component: Login
    },

    {
      path: "/buy",
      name: "buy",
      component: Buy
    },

    {
      path: "/debt",
      name: "debt",
      component: Debt
    },

    {
      path: "/approveConsignment",
      name: "approveConsignment",
      component: ApproveConsignment
    },

    {
      path: "/companies",
      name: "companies",
      component: Companies
    },

    {
      path: "/approvePurchase",
      name: "approvePurchase",
      component: ApprovePurchase
    },

    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard
    },

    {
      path: "/configs",
      name: "configs",
      component: Config
    },

    {
      path: "/consignment",
      name: "consignment",
      component: Consignment
    },

    {
      path: "/api",
      name: "api",
      component: Api
    },

    {
      path: "*",
      component: PageNotFound
    }
  ]
};

export default new Router(r);
